import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/')({
  validateSearch: zodValidator(withDefaults(schema.USER_MANAGEMENT, defaultFilter)),
});
